import { render } from "./KarriereWeiterbildung.vue?vue&type=template&id=22907a13"
import script from "./KarriereWeiterbildung.vue?vue&type=script&lang=ts"
export * from "./KarriereWeiterbildung.vue?vue&type=script&lang=ts"

import "./KarriereWeiterbildung.vue?vue&type=style&index=0&id=22907a13&lang=scss"
script.render = render

export default script